module.exports = __webpack_public_path__ + "static/media/mynaghi-loader.1ede930a.gif";